import $ from 'jquery';

$(document).ready(function () {
    setTimeout(() => {
        const arrowLink = $('.header-arrow-link');
        const arrowLinkWidth = arrowLink.outerWidth();
        arrowLink.css('width', arrowLinkWidth);
    }, 500);
});

$('.follow-popup-toggle').on('click', function () {
    $('.follow-popup').toggleClass('follow-popup-active');

    $(document).trigger('vipersModal', {
        open: $('.follow-popup').hasClass('follow-popup-active'),
    });
});

$('.menu-item-has-children > a').on('click', function (e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();

    const currentList = $(this).closest('li');
    const currentMenu = currentList.find('.sub-menu');
    const currentIcon = $(this).find('i');

    currentList.toggleClass('submenu-active');
    currentMenu.slideToggle('300');
    currentIcon.toggleClass('vipers-icons-plus vipers-icons-minus');
});

$('.header-nav-toggle').on('click', function () {
    $('.header-nav').toggleClass('header-nav-active');

    $(document).trigger('vipersModal', {
        open: $('.header-nav').hasClass('header-nav-active'),
    });
});

$(document).on('vipersModal', function (event, args) {
    const body = $('body');
    if (args.open) {
        body.addClass('vipers-modal-body');
    } else {
        body.removeClass('vipers-modal-body');
    }
});
